export default function Logo({ className = "h-7 w-7" }) {
  return (
    <img
      src="/logo.png"
      alt="The Consensus A.I."
      className={`${className} object-contain select-none`}
      draggable={false}
    />
  );
}
